export default {
    Email: 'Электронная почта',
    ConfirmEmail: 'Подтвердить электронную почту',
    Password: 'Пароль',
    Verificationcode: 'Код подтверждения',
    AlreadyhaveaHitPawaccountLogin: 'У вас уже есть учетная запись HitPaw? Войти',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'Регистрируясь, вы соглашаетесь с нашими Услугами использования и Политикой конфиденциальности.',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'Авторизуясь, вы соглашаетесь с нашими Услугами использования и Политикой конфиденциальности.',
    Byproceedingyouagreetoour: 'Регистрируясь/Авторизуясь, вы соглашаетесь с нашими ',
    ServicesofUse: 'Услугами использования',
    and: ' и ',
    PrivacyPolicy: 'Политикой конфиденциальности',
    last: '.',
    TheEmailformatisincorrect: 'Неправильный формат электронной почты',
    Pleaseenterthesameemailinbothfields:
        'Пожалуйста, введите один и тот же адрес электронной почты в оба поля.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'Пароль должен состоять из 8–50 символов и содержать как минимум две категории из следующих: цифра, буква или специальный символ.',
    Incorrectverificationcode: 'Неверный код подтверждения',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'Эта электронная почта была зарегистрирована, пожалуйста, выберите другую',
    Cannotbeemptyhere: 'Здесь не может быть пусто.',
    Rememberme: 'Запомнить пароль',
    ForgotPassword1: 'Забыли пароль?',
    NotaregistereduseryetSignUp: 'Вы еще не зарегистрировались? Зарегистрироваться',
    Notaregistereduseryet1: 'Вы еще не зарегистрировались? ',
    Notaregistereduseryet2: 'Зарегистрироваться',
    NoaccountfoundwiththatEmailaddress: 'Не найден аккаунт с такой электронной почтой',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Ваша электронная почта или пароль неверны. Пожалуйста, попробуйте еще раз.',
    ForgotPassword2: 'Забыть пароль',
    GetVerificationCode: 'Получить код подтверждения',
    VerifyEmail: 'Подтвердить почту',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'Он был отправлен на вашу почту, пожалуйста, проверьте его',
    PleaseinputEmailaddress: 'Пожалуйста, введите адрес электронной почты',
    TheEmailisnotregistered: 'Эта электронная почта не зарегистрирована',
    Invalidverificationcodepleasereenterthecorrectone:
        'Неверный проверочный код, введите правильный еще раз',
    Resetpassword: 'Сбросить пароль',
    Emailaddressverificationsucceeded: 'Электронная почта подтверждена успешно',
    Pleaseresetyourpassword: 'Пожалуйста, сбросьте ваш пароль',
    Enteranewpassword: 'Введите новый пароль',
    Confirm: 'Подтвердить',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'Новый пароль должен состоять из 8-50 символов, и состоять из английских букв или цифр или смеси букв и цифр.',
    Passwordresetsuccessfully: 'Пароль сброшен успешно',
    Name: 'Имя',
    GetCode: 'Получить код',
    Loginsuccessful: 'Войти успешно',
    Loginfailed: 'Не удалось войти',
    Signupsuccessful: 'Зарегистрироваться успешно',
    Signupfailed: 'Не удалось зарегистрироваться',
    Getpassword: 'Получить пароль',
    Authorizationhasexpiredpleaseloginagain:
        'Срок действия авторизации истек, пожалуйста, войдите снова.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'Извините, появилась ошибка, пожалуйста, попробуйте еще раз позже.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'За короткий период времени было сделано слишком много одинаковых запросов, пожалуйста, повторите попытку позже.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'Не удалось найти ваш аккаунт или указан неверный пароль.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'Вы пытаетесь получить доступ к платной функции, пожалуйста, сначала подпишитесь.',
    Accessdeniedfortheunauthorizedrequest: 'Access denied for the unauthorized request.',
    Alreadyhaveaccount: 'уже есть счёт?',
    SignUpwithemail: 'регистрация по электронной почте',
    Securityverification: 'проверка безопасности',
    Pleaseenterthecorrectemailaddress: 'Введите правильный адрес электронной почты!',
    PleaseInputverificationCode: 'Введите код проверки!',
    Pleaseenterthesamepasswordinbothfields: 'введите один и тот же пароль в двух полях!',
    or: 'или',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'Новый пароль, который вы ввели, совпадает с вашим старым паролем. Введите другой пароль',
    YourpasswordwasincorrectPleasetryagain:
        'Ваш пароль неверный. Пожалуйста, попробуйте еще раз.',
    reg400: 'Извините, появилась ошибка, пожалуйста, попробуйте еще раз позже.',
    reg400223: 'Электронная почта и проверочный код не совпадают, проверьте',
    reg400224: 'Токен просрочен',
    500: 'ошибка сервера!',
    Afewsecondsaway: 'В нескольких секундах отсюда',
    ContinuewithGoogle: 'Продолжить работу с Google',
    ContinuewithEmail: 'Продолжить с электронной почтой',
    LoginwithEmail: 'Войди в систему с помощью электронной почты',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'Использовать более 8 символов и смешивайте буквы, цифры и символы (поддерживайте символы: @$!%*#_~?&^)',
    ConfirmPassword: 'Подтвердить Пароль',
    Pleaseloginwithemail: 'Пожалуйста, войдите в систему с помощью электронной почты',
    youraccount: 'Ваша учетная запись',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'уже существует, для обеспечения безопасности вашей учетной записи, пожалуйста, сначала пройдите верификацию.',
    Login: 'Авторизоваться',
    exceed6Times: 'Ваша пробная версия истекла сегодня, пожалуйста, обновитесь до Pro, чтобы получить доступ ко всем премиальным функциям.',
    exceed20M: 'Размер файла для бесплатных учетных записей не может превышать 20 МБ, пожалуйста, обновитесь до Pro, чтобы получить доступ ко всем премиальным функциям.'
}